var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A181E",
    d: "M4.777 13.723c-.336-.337-.366-.863-.091-1.234l.091-.106L9.16 8 4.777 3.617c-.336-.336-.366-.862-.091-1.233l.091-.107c.337-.336.863-.366 1.234-.091l.106.091L11.17 7.33c.336.336.367.863.092 1.234l-.092.106-5.053 5.053c-.37.37-.97.37-1.34 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow1);
export default __webpack_public_path__ + "static/media/right-arrow-1.4b2a4732d33947b7694167ec2a8b9022.svg";
export { ForwardRef as ReactComponent };